import {
  ADMIN_MERCHANT_CREATE_REQUEST,
  ADMIN_MERCHANT_CREATE_SUCCESS,
  ADMIN_MERCHANT_CREATE_FAIL,
  ADMIN_MERCHANT_CREATE_RESET,
  ADMIN_MERCHANT_LIST_REQUEST,
  ADMIN_MERCHANT_LIST_SUCCESS,
  ADMIN_MERCHANT_LIST_FAIL,
  ADMIN_MERCHANT_LIST_SEARCH,
  ADMIN_MERCHANT_VIEW_REQUEST,
  ADMIN_MERCHANT_VIEW_SUCCESS,
  ADMIN_MERCHANT_VIEW_FAIL,
  MERCHANT_ADD_BRAND_REQUEST,
  MERCHANT_ADD_BRAND_SUCCESS,
  MERCHANT_ADD_BRAND_FAIL,
  MERCHANT_REMOVE_BRAND_REQUEST,
  MERCHANT_REMOVE_BRAND_SUCCESS,
  MERCHANT_REMOVE_BRAND_FAIL,
  ADMIN_MERCHANT_SEARCH_BRAND_REQUEST,
  ADMIN_MERCHANT_SEARCH_BRAND_SUCCESS,
  ADMIN_MERCHANT_SEARCH_BRAND_FAIL,
  ADMIN_MERCHANT_SEARCH_BRAND_RESET,
  ADMIN_MERCHANT_UPDATE_FAIL,
  ADMIN_MERCHANT_UPDATE_SUCCESS,
  ADMIN_MERCHANT_UPDATE_REQUEST,
  ADMIN_MERCHANT_UPDATE_RESET,
  MERCHANT_SELECT,
  MERCHANT_REMOVE,
} from "./merchantTypes";

export const merchantReducer = (state = { merchants: [] }, action) => {
  switch (action.type) {
    case MERCHANT_SELECT:
      return { ...state, loading: false, selectedMerchant: action.payload };
    case MERCHANT_REMOVE:
      return { ...state, selectedMerchant: null };

    case ADMIN_MERCHANT_VIEW_REQUEST:
      return { ...state, loading: true };

    case ADMIN_MERCHANT_LIST_REQUEST || ADMIN_MERCHANT_SEARCH_BRAND_REQUEST:
      return { ...state, loading: true };

    // CREATE MERCHANT
    case ADMIN_MERCHANT_CREATE_REQUEST:
      return { ...state, loading: true };
    // SUCCESS

    case ADMIN_MERCHANT_CREATE_SUCCESS:
      return { ...state, loading: false, success: true };

    case ADMIN_MERCHANT_CREATE_RESET:
      return { ...state, loading: false, success: false };

    case ADMIN_MERCHANT_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // CREATE MERCHANT
    case ADMIN_MERCHANT_UPDATE_REQUEST:
      return { ...state, loading: true };
    // SUCCESS

    case ADMIN_MERCHANT_UPDATE_SUCCESS:
      return { ...state, loading: false, success: true };

    case ADMIN_MERCHANT_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_MERCHANT_UPDATE_RESET:
      return { ...state, loading: false, success: false };
    // MERCHANT LIST
    case ADMIN_MERCHANT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        merchants: action.payload.merchants,
        totalMerchantCount: action.payload.totalMerchantCount,
      };
    // MERCHANT LIST
    case ADMIN_MERCHANT_LIST_SEARCH:
      return {
        ...state,
        loading: false,
        merchants: state.merchants.filter((m) => m.name.toLowerCase().includes(action.payload)),
      };
    case ADMIN_MERCHANT_VIEW_SUCCESS:
      return { ...state, merchant: action.payload, loading: false };

    case ADMIN_MERCHANT_SEARCH_BRAND_SUCCESS:
      return { ...state, search: action.payload, loading: false };

    case MERCHANT_ADD_BRAND_REQUEST:
      return { ...state, loading: true };

    case MERCHANT_ADD_BRAND_SUCCESS:
      return { ...state, merchant: action.payload, loading: false };

    case MERCHANT_ADD_BRAND_FAIL:
      return { ...state, loading: false, error: action.payload };

    // remove brand
    case MERCHANT_REMOVE_BRAND_REQUEST:
      return { ...state, loading: true };

    case MERCHANT_REMOVE_BRAND_SUCCESS:
      return { ...state, merchant: action.payload, loading: false };

    case MERCHANT_REMOVE_BRAND_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_MERCHANT_VIEW_FAIL || ADMIN_MERCHANT_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_MERCHANT_SEARCH_BRAND_RESET:
      return { ...state, search: {} };
    default:
      return state;
  }
};
